<template>
  <div class="list-settings">
    <settings-layout
      v-model="configs"
      :items="configs"
      :loading="serversLoading"
      :properties="properties"
      :img="configs.sample_image"
      @click:save="save"
    >
      <template #actions v-if="configs.id">
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
      <template #test><span></span></template>
    </settings-layout>
    <div v-if="configs.id && list_summary" class="list_summary">
      <hr class="hr-assets" />
      <router-link :to="{ name: 'list_items', params: configs.id }" class="button summary">
        <span
          ><b>{{ $t('lists.listItems') }}</b> ({{ list_summary }})</span
        >
      </router-link>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import SettingsLayout from '@/layout/SettingsLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'List',
  components: {
    SettingsLayout
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    })
  },
  data() {
    return {
      serversLoading: false,
      testLoading: false,
      configs: {},
      properties: {},
      list_summary: {}
    }
  },
  mounted() {
    if (this.$route.query.type !== undefined || this.$route.params.list_id !== undefined) {
      this.getDefaultConfig()
    } else {
      this.$router.push({
        name: 'lists'
      })
    }
  },
  methods: {
    ...mapActions('general', ['setTitle']),
    save() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list`
      this.configs.name = this.title
      this.serversLoading = true
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          list_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.listSaved'),
            type: 'success'
          })
          this.$router.push({
            name: 'lists'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
        })
    },
    getDefaultConfig() {
      if (!this.serversLoading) {
        const body = {}
        if (this.$route.query.type !== undefined) {
          body.type = this.$route.query.type
        }
        if (this.$route.params.list_id !== undefined) {
          body.list_id = this.$route.params.list_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list?${searchParams}`
        this.serversLoading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.configs = data.config
            this.properties = data.properties
            this.list_summary = data.list_summary
            this.setTitle(this.configs.name)
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    deleteList() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          list_ids: [this.$route.params.list_id]
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: this.configs.name
            }),
            type: 'success'
          })
          this.$router.push({ name: 'lists' })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: this.configs.name
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteList().finally(() => {
            this.serversLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.list-settings {
  .hr-assets {
    background-color: #c3c3c3;
  }
  .list_summary {
    .button {
      margin-right: 1rem;
      margin-bottom: 1rem;
      &.summary {
        border-color: #6cc8f3;
        background-color: #6cc8f3;
      }
    }
  }
}
</style>
